import {css} from "@panda/css";

export const outlinedChip = css.raw({
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-secondary)",
    borderRadius: 1,
    p: 1.5
});
import {css} from "@panda/css";

export const outlinedChip = css.raw({
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-secondary)",
    borderRadius: 1,
    p: 1.5
});
